import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { AppDialogProvider } from './components/AppDialog';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import { initFirebaseClient } from './lib/firebase';

// Intercept non-fatal Google Maps directions errors (e.g. DIRECTIONS_ROUTE: NOT_FOUND)
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const msg = typeof reason === 'string' ? reason : (reason?.message || '');
    if (msg.includes('DIRECTIONS_ROUTE') || msg.includes('Directions request')) {
      // Prevent uncaught error reporting for non-fatal directions query misses
      event.preventDefault();
      console.debug('Handled unhandled Directions promise rejection:', msg);
    }
  });

  const prevOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    const msgStr = typeof message === 'string' ? message : (error?.message || '');
    if (msgStr.includes('DIRECTIONS_ROUTE') || msgStr.includes('Directions request')) {
      console.debug('Handled global Directions error:', msgStr);
      return true; // Suppress reporting
    }
    if (prevOnError) {
      return prevOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

async function startApplication() {
  try {
    await initFirebaseClient();
  } catch (err) {
    console.warn('[Bootstrap] Initialized with fallback configuration:', err);
  }

  const { default: App } = await import('./App.tsx');
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <AppDialogProvider>
          <App />
        </AppDialogProvider>
      </ErrorBoundary>
    </StrictMode>,
  );
}

startApplication();

